module.exports = __webpack_public_path__ + "img/31-boy.4090e9c2.svg";